import { atom } from "jotai/index";

export const itemsAtom = atom({
  contract: null,
  data: [],
  balance: 0,
  loadCount: 0,
});
